import { render, staticRenderFns } from "./CreateCustomFieldModal.vue?vue&type=template&id=5cbb9217"
import script from "./CreateCustomFieldModal.vue?vue&type=script&lang=js"
export * from "./CreateCustomFieldModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports